import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
  ImageTitle,
} from './styled';

const BuySellTrade = ({ template }) => {
  const { messages, locale } = useIntl();

  const imageSection = (
    <ImageWrapper>
      <ImageTitle>Spendings</ImageTitle>
      <StyledImage
        src={messages[`${template}.buy-sell-trade.image.src`]}
        alt={messages[`${template}.buy-sell-trade.image.alt`]}
      />
    </ImageWrapper>
  );

  const contentSection = (
    <Contentwrapper>
      <Title locale={locale}>
        <FormattedMessage id={`${template}.buy-sell-trade.title`} />
      </Title>
      <Subtitle>
        <FormattedMessage id={`${template}.buy-sell-trade.paragraph`} />
      </Subtitle>
    </Contentwrapper>
  );

  return (
    <StyledSection>
      <StyledContentBlock>
        {template === 'bitcoin' ? (
          <>
            {contentSection}
            {imageSection}
          </>
        ) : (
          <>
            {imageSection}
            {contentSection}
          </>
        )}
      </StyledContentBlock>
    </StyledSection>
  );
};

BuySellTrade.propTypes = {
  template: PropTypes.string.isRequired,
};

export default BuySellTrade;
